<template>
  <div class="imagePopup">
    <van-popup :value="value" @input="val=>this.$emit('input',val)">
      <img :src="imgUrl" alt="头像预览">
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'imagePopup',
  props: {
    value: Boolean,
    imgUrl: String
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
  .imagePopup .van-popup {
    background-color: transparent;
    img {
      width: 300px;
      margin: 0 auto;
      height: 300px;
    }
  }
</style>
